var _path, _g, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemoproject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 83,
    viewBox: "0 0 90 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M73.5819 37.3604H16.4624L17.3857 64.7098C17.4356 65.8827 18.3839 66.806 19.5317 66.806H70.4876C71.6605 66.806 72.6087 65.8827 72.6337 64.7098L73.5819 37.3604Z",
    fill: "#D6DCE8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3022_83740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.582 36.3623L73.1827 47.8411L72.6337 63.7367C72.5838 64.9096 71.6356 65.8079 70.4877 65.8079H19.5318C18.359 65.8079 17.4107 64.8846 17.3857 63.7367L16.8368 47.8411L16.4375 36.3623H73.582Z",
    fill: "url(#paint0_linear_3022_83740)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0953 29.5749H36.9252C34.6045 29.5749 32.7329 27.7034 32.7329 25.3827V20.1923C32.7329 17.8715 34.6045 16 36.9252 16H53.0953C55.416 16 57.2876 17.8715 57.2876 20.1923V25.3827C57.2876 27.7034 55.416 29.5749 53.0953 29.5749ZM36.9252 18.9945C36.2764 18.9945 35.7274 19.5435 35.7274 20.1923V25.3827C35.7274 26.0315 36.2764 26.5805 36.9252 26.5805H53.0953C53.7441 26.5805 54.2931 26.0315 54.2931 25.3827V20.1923C54.2931 19.5435 53.7441 18.9945 53.0953 18.9945H36.9252Z",
    fill: "url(#paint1_linear_3022_83740)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4575 45.4956H16.5626C15.0154 45.4956 13.8426 44.1481 14.0173 42.6259L15.9637 26.0565C16.0884 25.0084 16.9618 24.2349 18.0099 24.2349H71.9852C73.0333 24.2349 73.9316 25.0334 74.0314 26.0565L75.9778 42.6259C76.1775 44.1481 75.0046 45.4956 73.4575 45.4956Z",
    fill: "url(#paint2_linear_3022_83740)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7598 50.0619H26.2699C25.7708 50.0619 25.3716 49.6627 25.3716 49.1636V43.6737C25.3716 43.1747 25.7708 42.7754 26.2699 42.7754H31.7598C32.2589 42.7754 32.6581 43.1747 32.6581 43.6737V49.1636C32.6581 49.6627 32.2589 50.0619 31.7598 50.0619ZM27.1683 48.2403H30.8614V44.5471H27.1683V48.2403Z",
    fill: "url(#paint3_linear_3022_83740)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.751 50.0619H58.2611C57.7621 50.0619 57.3628 49.6627 57.3628 49.1636V43.6737C57.3628 43.1747 57.7621 42.7754 58.2611 42.7754H63.751C64.2501 42.7754 64.6493 43.1747 64.6493 43.6737V49.1636C64.6493 49.6627 64.2501 50.0619 63.751 50.0619ZM59.1844 48.2403H62.8776V44.5471H59.1844V48.2403Z",
    fill: "url(#paint4_linear_3022_83740)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3022_83740",
    x: 4.98722,
    y: 30.6372,
    width: 80.0451,
    height: 52.3464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.72514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.72514
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3022_83740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3022_83740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3022_83740",
    x1: 44.9911,
    y1: 35.6812,
    x2: 44.9911,
    y2: 66.1254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3022_83740",
    x1: 45.0102,
    y1: 16,
    x2: 45.0102,
    y2: 29.5749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0142289,
    stopColor: "#33DCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3022_83740",
    x1: 41.3245,
    y1: 50.6112,
    x2: 40.983,
    y2: 23.0307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.415197,
    stopColor: "#818EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828138,
    stopColor: "#B2B9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3022_83740",
    x1: 29.506,
    y1: 44.3966,
    x2: 31.4378,
    y2: 49.9826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57ACE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BD0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3022_83740",
    x1: 61.4972,
    y1: 44.3966,
    x2: 63.429,
    y2: 49.9826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57ACE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BD0FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoproject);
export default __webpack_public_path__ + "static/media/demoproject.93041f52b79bfdd4c0a902e24aa51155.svg";
export { ForwardRef as ReactComponent };